import { Stack, Typography, CircularProgress, Breadcrumbs, Link, Box, TextField, Button, Breakpoint } from "@mui/material";
import { connect } from "react-redux";
import { actionCreators } from "../../store";
import FetchHelper from "../FetchHelper";
import { WIDTH_AGGRID, WIDTH_DASHBOARD_LEFT } from "../../models/Constants";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Path as RoutePath } from "../../path";
import useResponsive from "../../hooks/useResponsive";
import AddFileQuestionDialog from "../dialogs/AddFileQuestionDialog";
import ChangePasswordDialog from "../dialogs/ChangePasswordDialog";
import ShowQuestionListDialog from "../dialogs/ShowQuestionListDialog";
import AddTrackLineDialog from "../dialogs/AddTrackLineDialog";

const GET_QUESTION_LIST = "GET_QUESTION_LIST"
const CHANGE_PASSWORD = "CHANGE_PASSWORD"
const ADD_QUESTION_LIST = "ADD_QUESTION_LIST"
const GET_TRACK_LINE_DIALOG = "GET_TRACK_LINE_DIALOG"
const EDIT_TRACK_LINE = "EDIT_TRACK_LINE"

export type SettingPage = 
    ReturnType<typeof mapStateToProps> 
    & ReturnType<typeof mapDispatchToProps>
export const SettingPage = (props: SettingPage) => {
    //#region Fields
    const {
        onAddQuestionList,
        onAddQuestionListError,
        onAddQuestionListSuccess,
        onQuestionListFormatError,
        onGetQuestionList,
        onChangePassword,
        onChangePasswordError,
        onChangePasswordIncorrect,
        onChangePasswordSuccess,
        onLogout,
        onEditTrackLine,
        onEditTrackLineError,
        onEditTrackLineSuccess,
        onGetTrackLine
    } = props;

    const isDesktop = useResponsive({ query: 'up', key: 'lg' as Breakpoint });
    const isTablet = useResponsive({ query: 'up', key: 'md' as Breakpoint });

    const [loadingFlag, setLoadingFlag] = useState(false);
    const navigate = useNavigate()

    const [openAddFileDialog, setOpenAddFileDialog] = useState(false);
    const [openAddTrackLineDialog, setOpenAddTrackLineDialog] = useState({isOpen:false,data:null});
    const [openChangePasswordDialog, setOpenChangePasswordDialog] = useState(false);
    const [openShowQuestionListDialog, setOpenShowQuestionListDialog] = useState({isOpen:false,data:[]});

    const handleOpenAddFile = () => {
        setOpenAddFileDialog(true)
    }

    const handleCancelAddFile = () => {
        setOpenAddFileDialog(false)
    }

    const handleOkAddFile = (data:any) => {
        if(data && data.content &&  data.content.length == 100)
        {
            setLoadingFlag(true)
            onAddQuestionList({
                data : data.content
            })
        }
        else
        {
            onQuestionListFormatError()
        }
        setOpenAddFileDialog(false)
    }

    const handleAddQuestionListSuccess = (data:any) =>{
        if(data.resultCode == 0)
        {
            setLoadingFlag(false)
            onAddQuestionListSuccess()
        }
    }

    const handleAddQuestionListError = (data:any) =>{
        setLoadingFlag(false)
        onAddQuestionListError()
    }

    const handleOpenTrackLineDialog = () => {
        setLoadingFlag(true)
        onGetTrackLine({})
    }

    const handleCancelAddTrackLine = () => {
        setOpenAddTrackLineDialog({isOpen:false,data:null})
    }

    const handleOkAddTrackLine = (data:any) => {
        if(data)
        {
            setLoadingFlag(true)
            onEditTrackLine(data)
        }
        setOpenAddTrackLineDialog({isOpen:false,data:null})
    }

    const handleGetTrackLineSuccess = (data:any) => {
        setLoadingFlag(false)
        if(data.resultCode == 0)
        {
            setOpenAddTrackLineDialog({isOpen:true,data:data.data})
        }
    }
    
    const handleGetTrackLineError = (data:any) => {
        setOpenAddTrackLineDialog({isOpen:false,data:null})
        setLoadingFlag(false)
    }

    const handleEditTrackLineSuccess = (data:any) => {
        setLoadingFlag(false)
        onEditTrackLineSuccess()
    }

    const handleEditTrackLineError = (data:any) => {
        setLoadingFlag(false)
        onEditTrackLineError()
    }

    const handleOpenChangePassword = () => {
        setOpenChangePasswordDialog(true)
    }

    const handleCancelChangePassword = () => {
        setOpenChangePasswordDialog(false)
    }

    const handleOkChangePassword = (data:any) => {
        if(data)
        {
            setLoadingFlag(true)
            onChangePassword({
                oldPassword: data.oldPassword,
                newPassword: data.newPassword
            })
        }
    }

    const handleChangePasswordSuccess = (data:any) =>{
        setLoadingFlag(false)
        if(data && data.data.isSuccess)
        {
            setOpenChangePasswordDialog(false)
            onChangePasswordSuccess()
            onLogout()
        }
        else
        {
            onChangePasswordIncorrect()
        }
    }

    const handleChangePasswordError = (data:any) =>{
        setLoadingFlag(false)
        onChangePasswordError()
    }

    const handleOpenShowQuestionList = () => {
        setLoadingFlag(true)
        onGetQuestionList({})
    }

    const handleCancelShowQuestionList = () => {
        setOpenShowQuestionListDialog({isOpen:false,data:[]})
    }

    const handleGetQuestionListSuccess = (data:any) =>{
        setOpenShowQuestionListDialog({isOpen:true,data:data.data})
        setLoadingFlag(false)
    }

    const handleGetQuestionListError = (data:any) =>{
        setLoadingFlag(false)
    }

    return (          
        <>
            {loadingFlag && (
                <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1500, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                    <CircularProgress />
                </div>
            )}
            <Stack position='absolute' style={{ marginLeft:WIDTH_DASHBOARD_LEFT,marginTop:"20px"}} width={WIDTH_AGGRID}>
                <Breadcrumbs sx={{height:"50px",alignItems:"center",display:"flex",flexDirection:"row", marginLeft:"20px", fontSize:22}}  aria-label="breadcrumb">
                    <Link underline="hover" key="1" color="black" href={undefined} onClick={()=> navigate(RoutePath.home,{state:{isTestList:false,isUserList:false,isSetting:true}})} ml={2} >
                    設定管理
                    </Link>
                </Breadcrumbs>

                <Stack direction='row' justifyContent={"flex-start"} alignItems={"flex-start"} marginInline={isDesktop?10:5} mt={4} width={"90%"}>
                    <Box
                        sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        direction:"column",
                        padding: 2,
                        border:"0.5px solid #D3D3D3",
                        borderRadius:4,
                        position:"relative",
                        width:isDesktop?"28%":"40%",
                        "&:hover": {border:"0.5px solid gray"},
                        "&:hover .hover-text": {fontWeight:"bold"}
                        }}
                    >
                        <Stack top={-11} position={"absolute"} sx={{backgroundColor:"white"}}>
                            <Typography className="hover-text" fontSize={18} marginInline={"10px"}>質問ファイル管理</Typography>
                        </Stack>
                        <Stack sx={{width:"100%", alignItems:"center"}} spacing={5} mt={5} mb={5}>
                            <Button variant="contained" sx={{width:isDesktop?"60%":"70%"}} onClick={handleOpenShowQuestionList}>質問表示</Button>
                            <Button variant="contained" sx={{width:isDesktop?"60%":"70%"}} onClick={handleOpenAddFile}>質問ファイル更新</Button>
                        </Stack>
                    </Box>

                    <Stack direction='column' justifyContent={"flex-start"} alignItems={"flex-start"} width={isDesktop?"28%":"40%"}>
                        <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            direction:"column",
                            padding: 2,
                            border:"0.5px solid #D3D3D3",
                            borderRadius:4,
                            position:"relative",
                            width:"100%",
                            marginLeft:isDesktop?"60px":"30px",
                            "&:hover": {border:"0.5px solid gray"},
                            "&:hover .hover-text": {fontWeight:"bold"}
                            }}
                        >
                            <Stack top={-11} position={"absolute"} sx={{backgroundColor:"white"}}>
                                <Typography className="hover-text" fontSize={18} marginInline={"10px"} >アドレス管理</Typography>
                            </Stack>
                            <Stack sx={{width:"100%", alignItems:"center"}} spacing={5} mt={5} mb={5}>
                                <Button variant="contained" sx={{width:isDesktop?"60%":"70%"}} onClick={handleOpenChangePassword}>パスワード変更</Button>
                            </Stack>
                        </Box>

                        <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            direction:"column",
                            padding: 2,
                            border:"0.5px solid #D3D3D3",
                            borderRadius:4,
                            position:"relative",
                            width:"100%",
                            marginLeft:isDesktop?"60px":"30px",
                            marginTop:isDesktop?"50px":"30px",
                            "&:hover": {border:"0.5px solid gray"},
                            "&:hover .hover-text": {fontWeight:"bold"}
                            }}
                        >
                            <Stack top={-11} position={"absolute"} sx={{backgroundColor:"white"}}>
                                <Typography className="hover-text" fontSize={18} marginInline={"10px"} >診断管理</Typography>
                            </Stack>
                            <Stack sx={{width:"100%", alignItems:"center"}} spacing={5} mt={5} mb={5}>
                                <Button variant="contained" sx={{width:isDesktop?"60%":"70%"}} onClick={handleOpenTrackLineDialog}>ボーダー設定</Button>
                            </Stack>
                        </Box>
                    </Stack>

                </Stack>
                
            </Stack>
            {openAddFileDialog &&
                <AddFileQuestionDialog onCancel={handleCancelAddFile} onOK={handleOkAddFile}/>
            }

            {openChangePasswordDialog &&
                <ChangePasswordDialog onCancel={handleCancelChangePassword} onOK={handleOkChangePassword}/>
            }
            
            {openShowQuestionListDialog.isOpen &&
                <ShowQuestionListDialog data={openShowQuestionListDialog.data} onCancel={handleCancelShowQuestionList}/>
            }

            {openAddTrackLineDialog.isOpen &&
                <AddTrackLineDialog data={openAddTrackLineDialog.data} onCancel={handleCancelAddTrackLine} onOK={handleOkAddTrackLine}/>
            }
            
            <FetchHelper
                fetchId={ADD_QUESTION_LIST}
                onComplete={(success, data, error) =>{
                        success ? handleAddQuestionListSuccess(data) : handleAddQuestionListError(data)
                    }
                }
            />

            <FetchHelper
                fetchId={GET_QUESTION_LIST}
                onComplete={(success, data, error) =>{
                        success ? handleGetQuestionListSuccess(data) : handleGetQuestionListError(data)
                    }
                }
            />

            <FetchHelper
                fetchId={CHANGE_PASSWORD}
                onComplete={(success, data, error) =>{
                        success ? handleChangePasswordSuccess(data) : handleChangePasswordError(data)
                    }
                }
            />

            <FetchHelper
                fetchId={GET_TRACK_LINE_DIALOG}
                onComplete={(success, data, error) =>{
                        success ? handleGetTrackLineSuccess(data) : handleGetTrackLineError(data)
                    }
                }
            />

            <FetchHelper
                fetchId={EDIT_TRACK_LINE}
                onComplete={(success, data, error) =>{
                        success ? handleEditTrackLineSuccess(data) : handleEditTrackLineError(data)
                    }
                }
            />
        </>  
    );
};

const mapStateToProps = (state: any) => {
    return {
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
        onGetQuestionList:(params:any) =>dispatch(actionCreators.fetch(GET_QUESTION_LIST,'/question/get-question','POST',params,false,true)),
        onChangePassword:(params:any) =>dispatch(actionCreators.fetch(CHANGE_PASSWORD,'/user/edit-admin','POST',params,false,true)),
        onAddQuestionList:(params:any) =>dispatch(actionCreators.fetch(ADD_QUESTION_LIST,'/question/add-question','POST',params,false,true)),
        onGetTrackLine:(params:any) =>dispatch(actionCreators.fetch(GET_TRACK_LINE_DIALOG,'/user/get-track-line','POST',params,false,true)),
        onEditTrackLine:(params:any) =>dispatch(actionCreators.fetch(EDIT_TRACK_LINE,'/user/edit-track-line','POST',params,false,true)),
        onEditTrackLineSuccess:()=>dispatch(actionCreators.showMessage({
            type: "info",
            title: "ボーダー設定",
            body: "ボーダー設定が正常に変更されました",
        })),
        onEditTrackLineError:()=>dispatch(actionCreators.showMessage({
            type: "error",
            title: "ボーダー設定",
            body: "ボーダー設定の変更に失敗しました",
        })),
        onChangePasswordSuccess:()=>dispatch(actionCreators.showMessage({
            type: "info",
            title: "パスワード変更",
            body: "パスワードが正常に変更されました",
        })),
        onChangePasswordError:()=>dispatch(actionCreators.showMessage({
            type: "error",
            title: "パスワード変更",
            body: "パスワードの変更に失敗しました",
        })),
        onChangePasswordIncorrect:()=>dispatch(actionCreators.showMessage({
            type: "warning",
            title: "パスワード変更",
            body: "パスワードが間違っています",
        })),
        onAddQuestionListSuccess:()=>dispatch(actionCreators.showMessage({
            type: "info",
            title: "質問リストを追加",
            body: "質問リストが更新されました。",
        })),
        onAddQuestionListError:()=>dispatch(actionCreators.showMessage({
            type: "error",
            title: "質問リストを追加",
            body: "リストの質問の追加にエラーが発生しました",
        })),
        onQuestionListFormatError:()=>dispatch(actionCreators.showMessage({
            type: "error",
            title: "質問リストを追加",
            body: "質問リストの形式が正しくないためエラーです",
        })),
        onLogout: () => dispatch(actionCreators.clearSession()) 
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SettingPage);